export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
        subadmin_module_id: null,
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
        subadmin_module_id: null,

    },

    {
        id: 3,
        label: "menuitems.customers.text",
        link: "/customers",
        icon: "bxs-user",
        subadmin_module_id: 1,
    },

    

    {
        id: 5,
        label: "menuitems.fuelstations.text",
        link: "/fuel-stations",
        icon: "bx-gas-pump",
        subadmin_module_id: 2,
    },

    {
        id: 15,
        label: "menuitems.fsfuels.text",
        link: "/fuel-station-fuels",
        icon: "bx-filter-alt",
        subadmin_module_id: 2,
    },    
  

    {
        id: 6,
        label: "menuitems.trucks.text",
        link: "",
        icon: "bxs-truck",
        subadmin_module_id: 3,

        subItems: [
            {
                id: 7,
                label: "menuitems.trucks.list.pending",
                link: "/pending-trucks",
                parentId: 6
            },
            {
                id: 8,
                label: "menuitems.trucks.list.approved",
                link: "/trucks",
                parentId: 6
            },
        ]
    },
    

    {
        id: 9,
        label: "menuitems.drivers.text",
        link: "",
        icon: "bx-user-circle",
        subadmin_module_id: 4,
        
        subItems: [
            {
                id: 10,
                label: "menuitems.drivers.list.pending",
                link: "/pending-drivers",
                parentId: 9
            },
            {
                id: 11,
                label: "menuitems.drivers.list.approved",
                link: "/drivers",
                parentId: 9
            },
           
        ]
    },

    {
        id: 12,
        label: "menuitems.orders.text",
        link: "/orders",
        icon: "bx-cart",
        subadmin_module_id:5,
    },

  /*   {
        id: 17,
        label: "menuitems.reports.list.earnings",
        link: "/reports/earnings",
        icon: "bx-dollar-circle",
    }, */

    {
        id: 30,
        label: "menuitems.reports.text",
        link: "",
        icon: "bx-file",
        subadmin_module_id: 6,
        
        subItems: [
            {
                id: 31,
                label: "menuitems.reports.list.sales",
                link: "/reports/sales",
                parentId: 30
            },
            {
                id: 32,
                label: "menuitems.reports.list.earnings",
                link: "/reports/earnings",
                parentId: 30
            },
           
        ]
    },

    {
        id: 4,
        label: "menuitems.fuels.text",
        link: "/fuels",
        icon: "bx-droplet",
        subadmin_module_id: 7,
    },
    {
        id: 14,
        label: "menuitems.coupons.text",
        link: "/promotions",
        icon: "bxs-coupon",
        subadmin_module_id: 8,
    },

    {
        id: 16,
        label: "menuitems.broadcasts.text",
        link: "/broadcasts",
        icon: "bx-broadcast",
        subadmin_module_id: 9,
    },

    {
        id: 13,
        label: "menuitems.sliders.text",
        link: "/sliders",
        icon: "bx-slider-alt",
        subadmin_module_id: 10,
    },  

    {
        id: 18,
        label: "menuitems.ratings.text",
        link: "",
        icon: "bx-star",
        subadmin_module_id: 11,

        subItems: [
            {
                id: 19,
                label: "menuitems.ratings.list.customers",
                link: "/ratings/customers",
                parentId: 18
            },
            {
                id: 20,
                label: "menuitems.ratings.list.drivers",
                link: "/ratings/drivers",
                parentId: 18
            },
           
        ]
    },

    {
        id: 21,
        label: "menuitems.subadmins.text",
        link: "/subadmins",
        icon: "bx-group",
        subadmin_module_id: -1,

    },

    {
        id: 22,
        label: "menuitems.cms.text",
        link: "",
        icon: "bx-mobile",
        subadmin_module_id: 12,

        
        subItems: [
            {
                id: 23,
                label: "menuitems.cms.list.about",
                link: "/cms/about",
                parentId: 22
            },
            {
                id: 24,
                label: "menuitems.cms.list.terms",
                link: "/cms/terms-and-conditions",
                parentId: 22
            },
            {
                id: 25,
                label: "menuitems.cms.list.privacy",
                link: "/cms/privacy-policy",
                parentId: 22
            },
        ]
    },

    {
        id: 28,
        label: "menuitems.enquiries.text",
        link: "/enquiries",
        icon: "bx-message-square-dots",
        subadmin_module_id: 13,

    },

    {
        id: 29,
        label: "menuitems.settings.text",
        link: "/settings",
        icon: "bx-cog",
        subadmin_module_id: null,

    },

    
];

